import "./loading.css";
export default function LoadingUI() {
  return (
    <div className="w-full h-full min-h-[500px] flex items-center justify-center">
      <div className="loader"></div>
    </div>
  );
}
